import React, { Component } from 'react';
import gettext from '@eb/gettext';

import { Modal } from '@eb/eds-modal';
import { Button } from '@eb/eds-button';
import { MailChunky } from '@eb/eds-iconography';
import { AlertChunky } from '@eb/eds-iconography';

import GrayDialog from '../../components/LinkedAccountsGrayDialog';

const getStrings = ({ status, isLoading, textWithOfuscatedEmail }) => {
    let iconType = null;
    let headerText = gettext('Wait a second please. We are sending an email.');
    let subtitleTextDark = '';
    let subtitleText = '';
    let buttonText = '';
    const buttonRedirection = null;

    if (!isLoading) {
        iconType = <AlertChunky />;
        headerText = gettext('Linking Failed!');
        subtitleTextDark = gettext('Something went wrong');
        subtitleText = gettext('Please try again later');
        buttonText = gettext('Try again');
        // For the time beign all the texts for the failed status are placeholders, once we have the official copies these should be changed

        if (status === true) {
            iconType = <MailChunky />;
            headerText = gettext('Check your inbox');
            (subtitleTextDark = textWithOfuscatedEmail),
                (subtitleText = gettext(
                    "This link will expire in 2 hours, so don't wait too long!",
                ));
            buttonText = gettext('Close');
        }
    }

    const strings = {
        iconType,
        headerText,
        subtitleTextDark,
        subtitleText,
        buttonText,
    };

    return strings;
};

class MagicLinkAccountSectionModalButton extends Component {
    _handleClose = () => {
        this.props.setShowModal(false);
        this.props.closeMagicLinkModal();
    };

    // checks if api response is successful
    _handleOnClick = () => {
        if (this.props.onLinkAccount) {
            this.props.onLinkAccount();
        }
    };

    render() {
        const {
            isLoading,
            emailLinkAccount,
            showModal,
            textWithOfuscatedEmail,
        } = this.props;

        const {
            iconType,
            headerText,
            subtitleText,
            subtitleTextDark,
            buttonText,
        } = getStrings({
            status: emailLinkAccount,
            isLoading,
            textWithOfuscatedEmail,
        });

        return (
            <div className="eds-g-cell eds-g-cell-12-12 eds-example-modal-container">
                <Modal
                    noMinHeight={true}
                    modalBodyIsEmpty={true}
                    isShown={showModal}
                    onClose={this._handleClose}
                >
                    <GrayDialog
                        iconType={iconType}
                        headerText={headerText}
                        subtitleTextDark={subtitleTextDark}
                        subtitleText={subtitleText}
                        buttonText={buttonText}
                        handleOnClick={this._handleClose}
                        isLoading={isLoading}
                    />
                </Modal>
                <div className="eds-align--center eds-example-modal-container__inner">
                    <Button
                        style="fill"
                        size="block"
                        type="submit"
                        onClick={this._handleOnClick}
                        __containerClassName="modal-button"
                        data-automation="email-magic-link-button"
                    >
                        {this.props.modalButtonText}
                    </Button>
                </div>
            </div>
        );
    }
}

export default MagicLinkAccountSectionModalButton;
